module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Exodus-Gods-&-Kings.a9b3e3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Exodus-Gods-&-Kings.jpg
// module id = 98Ai
// module chunks = 0